import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import SoftBox from "components/SoftBox";


import DefaultQuestions from "./DefaultQuestions";
import ExternalVideos from "./ExternalVideos";
import DataSync from "./DataSync";
import Appearance from "./Appearence";
import RecaptchaSettings from "./Recaptcha";


export default function WebflowLayout() {
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event, newIndex) => {
    setTabIndex(newIndex);
  };

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, []);

  const renderTabContent = () => {
    switch (tabIndex) {
      case 0:
        return <DataSync />;
      case 1:
        return <Appearance />;
      case 2:
        return <DefaultQuestions />;
      case 3:
        return <RecaptchaSettings />;
      case 4:
        return <ExternalVideos />;
      default:
        return null;
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox px={2}>
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label="Data Sync" />
          <Tab label="Appearance" />
          <Tab label="Default Questions" />
          <Tab label="Google Recaptcha" />
          <Tab label="External Videos" />
        </Tabs>
        <SoftBox mt={3}>
          {renderTabContent()}
        </SoftBox>
      </SoftBox>
    </DashboardLayout>
  );
}
